import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'LineItemPreset') {
      child.current?.setState({ showModal: true, componentType: 'Create' });

      //必须如下顺序设置, 否则再次弹出时无法清空已选项
      setTimeout(() => {
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], LineItemPresetContentList: [] });
        child.current?.customForm.current?.formRef.current?.setFieldValue('LgaId', 0);
        child.current?.customForm.current?.formRef.current?.setFieldValue('JobTypeId', 0);
        child.current?.customForm.current?.formRef.current?.setFieldValue('CompanyOfficeId', 0);
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.getLineItemData();
      }, config.setTimeoutMilliSecond * 10);
    }
  })
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          if (data.data.LgaId === null) {
            data.data.LgaId = 0;
          }
          if (data.data.JobTypeId === null) {
            data.data.JobTypeId = 0;
          }
          if (data.data.CompanyOfficeId === null) {
            data.data.CompanyOfficeId = 0;
          }
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });

          //把处理后的数据赋值给表单
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });

          //获取编辑时的原 LineItemPresetContent 列表, 设置默认选中项 defaultSelectedRowKeys
          let defaultSelectedRowKeys = [];
          let lineItemPresetContentList = [];
          data.data.LineItemPresetContentList.map((LineItemPresetContent, i) => {
            defaultSelectedRowKeys.push(LineItemPresetContent.LineItemId);
            lineItemPresetContentList.push(LineItemPresetContent);
          })
          setTimeout(() => {
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys, lineItemPresetContentList });
            //先设置完默认选中项, 再获取实际 LineItem 列表, 否则会设置不上
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.getLineItemData();
          }, config.setTimeoutMilliSecond * 10);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}


export function resetSelectLineItemForm({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    formComponent?.formRef.current?.setFieldValue('LineItemPresetContentList', undefined);
    formComponent?.additionalFormRef.current?.child.current?.setState({
      data: [],
      filteredData: [],
      lineItemPresetContentList: [],
      defaultSelectedRowKeys: [],
    });
  }, 500);
}

export function cancelLineItemPresetPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  const formComponent = sectionComponent.customForm?.current;
  setTimeout(() => {
    formComponent?.formRef?.current?.setFieldValue('LineItemPresetContentList', undefined);
    formComponent?.additionalFormRef?.current?.child?.current?.setState({
      data: [],
      filteredData: [],
      lineItemPresetContentList: [],
      defaultSelectedRowKeys: [],
    });
  }, 500);
}

//打开排序弹框
export function showLineItemPresetSortDiv({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ lineItemPresetSortShow: true, currentLineItemPreset: parameter });
  pageComponent.lineItemPresetSortDiv.current?.setState({ loading: true });
  setTimeout(() => {
    pageComponent.lineItemPresetSortDiv.current?.loadContentList(parameter.key);
  }, config.setTimeoutMilliSecond);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let filteredData;
  if (parameter) {
    filteredData = sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data.map((folder) => {
      // 使用对象的拷贝
      let newFolder = { ...folder };
      newFolder.LineItemList = folder.LineItemList.filter((item) =>
        sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.lineItemPresetContentList.map(item => item.LineItemId).includes(item.key)
      );
      return newFolder;
    });
  } else {
    filteredData = [...sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data];
  }
  sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ filteredData });
}
